import React, { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IRegeneratePdfButton {
  id: number;
  setRefresh?: (refresh: boolean) => void;
}

const RegeneratePdfButton = ({ id, setRefresh }: IRegeneratePdfButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const regeneratePdfUrlInvoice = () => {
    setIsLoading(true);
    provider
      .customUpdate(`subcontractorPurchaseInvoices/${id}/generatePdf`, {})
      .then(({ data }: any) => {
        setIsLoading(false);
        notify("Successfully Generate PDF.");
        if (setRefresh) {
          setRefresh(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        notify("Error Generate PDF.", "warning");
      });
  };

  return (
    <StyledButton
      variant="outlined"
      onClick={regeneratePdfUrlInvoice}
      disabled={isLoading}
    >
      {isLoading ? "Loading" : "Regenerate PDF"}
    </StyledButton>
  );
};

export default RegeneratePdfButton;
